module.exports = "pegasus_template/assets/tech-logo.png";